(function () {
  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function initGallery(section) {
    const gallery = section.querySelector('[data-grefi-gallery]');
    if (!gallery) return null;

    const slides = [...gallery.querySelectorAll('[data-grefi-slide]')];
    if (slides.length <= 1) return null;

    const thumbs = [...gallery.querySelectorAll('[data-grefi-thumb]')];
    const dots = [...gallery.querySelectorAll('[data-grefi-dot]')];
    const counterCurrent = gallery.querySelector('[data-grefi-counter-current]');
    const counterTotal = gallery.querySelector('[data-grefi-counter-total]');
    const prevBtn = gallery.querySelector('[data-grefi-nav="prev"]');
    const nextBtn = gallery.querySelector('[data-grefi-nav="next"]');
    const slider = gallery.querySelector('[data-grefi-slider]');

    const autoplayEnabled = section.dataset.grefiAutoplay !== 'false';
    const speedSec = parseInt(section.dataset.grefiAutoplaySpeed, 10) || 4;
    const speedMs = speedSec * 1000;

    let index = slides.findIndex((s) => s.classList.contains('is-active'));
    if (index < 0) index = 0;

    let timer = null;
    let paused = false;

    function syncUI() {
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        const fill = dot.querySelector('.grefi-pdp__dot-fill');
        if (fill) {
          fill.style.animation = 'none';
          void fill.offsetWidth;
          if (i === index && autoplayEnabled && !paused) {
            fill.style.animation = `grefi-pdp-dot-fill ${speedSec}s linear forwards`;
          }
        }
      });
      if (counterCurrent) counterCurrent.textContent = pad2(index + 1);
      if (counterTotal) counterTotal.textContent = pad2(slides.length);
    }

    function goTo(i, userAction) {
      index = ((i % slides.length) + slides.length) % slides.length;
      syncUI();
      if (userAction) pauseAutoplay();
    }

    function next(userAction) {
      goTo(index + 1, userAction);
    }

    function prev(userAction) {
      goTo(index - 1, userAction);
    }

    function startAutoplay() {
      if (!autoplayEnabled || paused) return;
      clearInterval(timer);
      timer = setInterval(() => next(false), speedMs);
      syncUI();
    }

    function pauseAutoplay() {
      paused = true;
      clearInterval(timer);
      dots.forEach((dot) => {
        const fill = dot.querySelector('.grefi-pdp__dot-fill');
        if (fill) fill.style.animationPlayState = 'paused';
      });
      setTimeout(() => {
        paused = false;
        startAutoplay();
      }, speedMs * 2);
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const i = parseInt(thumb.dataset.index, 10);
        if (!Number.isNaN(i)) goTo(i, true);
      });
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const i = parseInt(dot.dataset.index, 10);
        if (!Number.isNaN(i)) goTo(i, true);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', () => prev(true));
    if (nextBtn) nextBtn.addEventListener('click', () => next(true));

    if (slider) {
      slider.addEventListener('mouseenter', () => {
        paused = true;
        clearInterval(timer);
      });
      slider.addEventListener('mouseleave', () => {
        paused = false;
        startAutoplay();
      });
      slider.addEventListener('focusin', () => {
        paused = true;
        clearInterval(timer);
      });
      slider.addEventListener('focusout', () => {
        paused = false;
        startAutoplay();
      });
    }

    syncUI();
    if (autoplayEnabled) startAutoplay();

    return {
      goToMediaId(mediaId) {
        const i = slides.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
        if (i >= 0) goTo(i, true);
      },
      destroy() {
        clearInterval(timer);
      },
    };
  }

  function initVideoScroller(section) {
    const root = section.querySelector('[data-grefi-video-scroller]');
    if (!root) return;

    const track = root.querySelector('[data-grefi-video-track]');
    const slides = [...root.querySelectorAll('[data-grefi-video-slide]')];
    const dots = [...root.querySelectorAll('[data-grefi-video-dot]')];
    const prevBtn = root.querySelector('[data-grefi-video-prev]');
    const nextBtn = root.querySelector('[data-grefi-video-next]');
    if (!track || slides.length === 0) return;

    let index = 0;
    let timer = null;
    let paused = false;
    const AUTO_MS = 3500;

    function syncDots() {
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    function playAll() {
      slides.forEach((s) => {
        const video = s.querySelector('video');
        if (!video) return;
        video.setAttribute('playsinline', '');
        video.muted = true;
        video.loop = true;
        video.play().catch(() => {});
      });
    }

    function goTo(i, fromUser) {
      index = ((i % slides.length) + slides.length) % slides.length;
      const slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      syncDots();
      playAll();
      if (fromUser) pauseAuto();
    }

    function startAuto() {
      if (slides.length < 2 || paused) return;
      clearInterval(timer);
      timer = setInterval(() => goTo(index + 1, false), AUTO_MS);
    }

    function pauseAuto() {
      paused = true;
      clearInterval(timer);
      setTimeout(() => {
        paused = false;
        startAuto();
      }, AUTO_MS * 2);
    }

    prevBtn?.addEventListener('click', () => goTo(index - 1, true));
    nextBtn?.addEventListener('click', () => goTo(index + 1, true));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const i = parseInt(dot.dataset.index, 10);
        if (!Number.isNaN(i)) goTo(i, true);
      });
    });

    let scrollTimer = null;
    track.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const left = track.scrollLeft;
          let nearest = 0;
          let best = Infinity;
          slides.forEach((slide, i) => {
            const d = Math.abs(slide.offsetLeft - left);
            if (d < best) {
              best = d;
              nearest = i;
            }
          });
          if (nearest !== index) {
            index = nearest;
            syncDots();
            playAll();
          }
        }, 60);
      },
      { passive: true }
    );

    track.addEventListener(
      'pointerdown',
      () => {
        pauseAuto();
      },
      { passive: true }
    );

    playAll();
    startAuto();

    // Keep playing if browser interrupts
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) playAll();
    });
  }

  function initProduct(section) {
    initVideoScroller(section);

    const form = section.querySelector('[data-grefi-product-form]');
    if (!form) return;

    const dataEl = section.querySelector('[data-grefi-product-json]');
    if (!dataEl) return;

    let product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch {
      return;
    }

    const galleryCtrl = initGallery(section);
    const variantInput = form.querySelector('[name="id"]');
    const priceEl = section.querySelector('[data-grefi-price]');
    const compareEl = section.querySelector('[data-grefi-compare]');
    const saveEl = section.querySelector('[data-grefi-save]');
    const atcBtn = form.querySelector('[data-grefi-atc]');
    const atcText = form.querySelector('[data-grefi-atc-text]');
    const buyBtn = form.querySelector('[data-grefi-buy-now]');
    const buyText = form.querySelector('[data-grefi-buy-text]');
    const badgeEl = section.querySelector('[data-grefi-badge]');
    const optionBtns = section.querySelectorAll('[data-grefi-option-value]');
    const qtyInput = form.querySelector('[data-grefi-qty]');
    const qtyMinus = form.querySelector('[data-grefi-qty-minus]');
    const qtyPlus = form.querySelector('[data-grefi-qty-plus]');

    const selected = {};
    const cartAddUrl =
      window.Shopify?.routes?.root != null
        ? `${window.Shopify.routes.root}cart/add.js`
        : '/cart/add.js';
    const checkoutUrl = window.grefiCheckout?.checkoutUrl || '/checkout';

    product.options.forEach((name, i) => {
      const v = product.variants.find((x) => x.id === product.selected_or_first_available_variant?.id);
      if (v) selected[name] = v[`option${i + 1}`];
    });

    function formatMoney(cents) {
      if (window.Shopify?.formatMoney) {
        return Shopify.formatMoney(cents, window.theme?.moneyFormat || Shopify.money_format);
      }
      return '₹' + (cents / 100).toFixed(0);
    }

    function findVariant() {
      return product.variants.find((v) =>
        product.options.every((opt, i) => v[`option${i + 1}`] === selected[opt])
      );
    }

    async function addToCart() {
      const id = Number(variantInput?.value);
      const quantity = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
      if (!id) throw new Error('Missing variant');

      const res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: [{ id, quantity }] }),
      });

      if (!res.ok) {
        let message = 'Could not add to cart';
        try {
          const err = await res.json();
          message = err.description || err.message || message;
        } catch {
          /* ignore */
        }
        throw new Error(message);
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
      return res.json();
    }

    function goCheckout() {
      if (typeof window.grefiStartCheckout === 'function') {
        window.grefiStartCheckout(buyBtn);
        return;
      }
      window.location.href = checkoutUrl;
    }

    function updateUI(variant) {
      if (!variant) {
        if (atcBtn) {
          atcBtn.disabled = true;
          if (atcText) atcText.textContent = atcBtn.dataset.unavailable || 'Unavailable';
        }
        if (buyBtn) buyBtn.disabled = true;
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      const onSale = variant.compare_at_price > variant.price;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.classList.toggle('grefi-pdp__price--sale', onSale);
      }

      if (compareEl) {
        if (onSale) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (saveEl) {
        if (onSale) {
          const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          saveEl.textContent = 'Save ' + pct + '%';
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }

      if (badgeEl) {
        if (!variant.available) {
          badgeEl.textContent = badgeEl.dataset.soldOut || 'Sold Out';
          badgeEl.className = 'grefi-pdp__badge';
          badgeEl.hidden = false;
        } else if (onSale) {
          badgeEl.textContent = badgeEl.dataset.sale || 'Sale';
          badgeEl.className = 'grefi-pdp__badge grefi-pdp__badge--sale';
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
        }
      }

      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        const label = variant.available
          ? atcBtn.dataset.add || 'Add to Cart'
          : atcBtn.dataset.soldOut || 'Sold Out';
        if (atcText) atcText.textContent = label;
      }

      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        if (buyText && !buyBtn.classList.contains('is-loading')) {
          buyText.textContent = buyBtn.dataset.label || 'Buy Now';
        }
      }

      if (variant.featured_image && galleryCtrl) {
        const mediaId = variant.featured_image.id || variant.featured_media_id;
        if (mediaId) galleryCtrl.goToMediaId(mediaId);
      }

      optionBtns.forEach((btn) => {
        const opt = btn.dataset.option;
        const val = btn.dataset.value;
        btn.classList.toggle('is-selected', selected[opt] === val);

        const test = { ...selected, [opt]: val };
        const match = product.variants.find((v) =>
          product.options.every((o, i) => v[`option${i + 1}`] === test[o])
        );
        btn.classList.toggle('is-disabled', !match || !match.available);
      });
    }

    optionBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-disabled')) return;
        selected[btn.dataset.option] = btn.dataset.value;
        updateUI(findVariant());
      });
    });

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        const min = parseInt(qtyInput.min, 10) || 1;
        qtyInput.value = Math.max(min, parseInt(qtyInput.value, 10) - 1);
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', () => {
        const max = qtyInput.max ? parseInt(qtyInput.max, 10) : 99;
        qtyInput.value = Math.min(max, parseInt(qtyInput.value, 10) + 1);
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', async () => {
        if (buyBtn.disabled || buyBtn.classList.contains('is-loading')) return;

        buyBtn.classList.add('is-loading');
        buyBtn.disabled = true;
        if (buyText) buyText.textContent = buyBtn.dataset.loading || 'Redirecting…';

        try {
          await addToCart();
          goCheckout();
          /* Do NOT force /checkout — that kills Shiprocket on mobile.
             Guard owns fallback only if Shiprocket never opens. */
        } catch (err) {
          buyBtn.classList.remove('is-loading');
          buyBtn.disabled = false;
          if (buyText) buyText.textContent = buyBtn.dataset.label || 'Buy Now';
          window.alert(err.message || 'Could not start checkout');
        }
      });
    }

    section.querySelectorAll('[data-grefi-acc-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('[data-grefi-acc-item]');
        const open = item.classList.contains('is-open');
        section.querySelectorAll('[data-grefi-acc-item]').forEach((el) => el.classList.remove('is-open'));
        if (!open) item.classList.add('is-open');
      });
    });

    const initial = product.selected_or_first_available_variant || product.variants[0];
    if (initial) updateUI(initial);
  }

  function boot() {
    document.querySelectorAll('.grefi-pdp-section').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector?.('.grefi-pdp-section') || e.target.closest?.('.grefi-pdp-section');
    if (section) initProduct(section.closest('.shopify-section') || section);
  });
})();
